import { useEffect, useRef, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ApiServices from '../config/ApiServices';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import Loader from '../utils/Loader';

// Register the necessary components
Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const PerformanceGraph = ({ title }) => {
    const [data, setData] = useState(null); // Initialize as null
    const [loading, setLoading] = useState(true);
    const { batchId, studentId } = useParams();
    const [taskType,setTaskType]=useState(1)
    const chartRef = useRef(null);

    useEffect(() => {
        // const fetchData = async () => {
        //     try {
        //         // Fetch the scores for each test
        //         const marksResponse = await ApiServices.apiRequest('getMarks', { studentId: studentId });
        //         if (marksResponse.data.success) {
        //             const marks = marksResponse.data.data;
        //             // Combine the test details and scores
        //             const combinedData = marks.map(mark => {
        //                 return {
        //                     testName: "Test",
        //                     percentage: mark && mark.testId && mark.testId.maximumMarks
        //                         ? (mark.score / mark.testId.maximumMarks) * 100
        //                         : 0,
        //                     score: mark ? mark.score : 0,
        //                     maxMarks: mark?.testId?.maximumMarks ? mark?.testId?.maximumMarks : 0
        //                 };
        //             });
        //             // Prepare data for the graph
        //             const labels = combinedData.map(item => `${item.testName} (${item.percentage.toFixed(2)}%)`);
        //             const percentages = combinedData.map(item => item.percentage);

        //             setData({
        //                 labels,
        //                 datasets: [
        //                     {
        //                         label: 'Percentage',
        //                         data: percentages,
        //                         backgroundColor: 'rgba(75,192,192,0.2)',
        //                         borderColor: 'rgba(75,192,192,1)',
        //                         borderWidth: 1,
        //                         barThickness: 40, // Set the bar thickness here
        //                     }
        //                 ],
        //             });

        //             // Update tooltip to show score and max marks
        //             Chart.defaults.plugins.tooltip.callbacks.label = function(tooltipItem) {
        //                 const item = combinedData[tooltipItem.dataIndex];
        //                 return `Score: ${item.score} / ${item.maxMarks}`;
        //             };
        //         } else {
        //             toast.error(marksResponse.data.message);
        //         }
        //     } catch (error) {
        //         toast.error('Error fetching data');
        //     } finally {
        //         setLoading(false);
        //     }
        // };
    
        fetchData();

        return () => {
            // Destroy the chart instance on component unmount
            if (chartRef.current) {
                if (chartRef.current.chartInstance) {
                    chartRef.current.chartInstance.destroy();
                }
            }
        };
    }, [studentId, taskType]);
    const fetchData=  ()=>{
        let data={
            studentId:studentId,
            batchId:batchId
        }
        ApiServices.apiRequest("studentPerformance",data)
        .then((res)=>{
            if(res.data.success){
               let combinedData=[]
               if(taskType==1){
                combinedData=[...res.data.data.assignments?.tasks, ...res.data.data.tests?.tasks]
               }else if (taskType==2){
                combinedData=res.data.data.assignments?.tasks
               }
               else{
                combinedData=res.data.data.tests?.tasks
               }
            const filterData=combinedData.filter(mark=>{
                if(mark.score!=null){
                    return mark
                }
            })
            const changedData = filterData.map(mark => {
                return {
                    testName: mark.taskName,
                    percentage: mark && mark.maximumMarks
                        ? (mark.score / mark.maximumMarks) * 100
                        : 0,
                    score: mark ? mark.score : 0,
                    maxMarks: mark?.maximumMarks ? mark?.maximumMarks : 0
                };
            });
                 // Prepare data for the graph
                const labels = changedData.map(item => `${item.testName} (${item.percentage.toFixed(2)}%)`);
                const percentages = changedData.map(item => item.percentage);
               setData({
                    labels,
                    datasets: [
                        {
                            label: 'Percentage',
                            data: percentages,
                            backgroundColor: 'rgba(75,192,192,0.2)',
                            borderColor: 'rgba(75,192,192,1)',
                            borderWidth: 1,
                            barThickness: 40, // Set the bar thickness here
                        }
                    ],
                });

                // Update tooltip to show score and max marks
                Chart.defaults.plugins.tooltip.callbacks.label = function(tooltipItem) {
                    const item = changedData[tooltipItem.dataIndex];
                    return `Score: ${item.score} / ${item.maxMarks}`;
                };
            } else {
                toast.error(res.data.message);
            }
        }).catch((error)=>{
            toast.error('Error fetching data');
        }).finally(()=> {
            setLoading(false);
        })
    }
    if (loading) {
        return <div>Loading...</div>;
    }

    if (!data) {
        return <div>No data available</div>;
    }

    return (
        <>
            <div className="container">
                <div className="page-inner">
                    {loading ?
                        <Loader />
                        :
                        <>
                            <div className="d-flex justify-content-between align-items-center  flex-column flex-md-row pt-2 pb-4">
                                <div>
                                    <h3 className="fw-bold mb-3">{title}</h3>
                                </div>
                                <select className='w-25 form-control' value={taskType} onChange={(e)=>{setTaskType(e.target.value)}}>
                                    <option value={1}>All</option>
                                    <option value={2}>Assignments</option>
                                    <option value={3}>Tests</option>
                                </select>
                            </div>
                            <Bar key={studentId} ref={chartRef} data={data} options={{
                                scales: {
                                    x: {
                                        ticks: {
                                            callback: function (value, index, values) {
                                                return this.getLabelForValue(value);
                                            },
                                            maxRotation: 90,
                                            minRotation: 45
                                        }
                                    },
                                    y: {
                                        beginAtZero: true,
                                        max: 100
                                    }
                                }
                            }} />
                        </>
                    }
                </div>
            </div>
        </>
    );
};

export default PerformanceGraph;
